import React, { useState } from 'react';
import styles from './styles.less';
import Loading from '../Loading';
import { APIError } from '../../api/types';
import Exception from '../Exception';
import { IS_POS } from '@/utils/env';
import PosButton from '../PosButton';
import { DownOutlined } from '@ant-design/icons';

type AsyncWrapperProps = {
  children: () => React.ReactNode;

  /**显示加载中 */
  loading?: boolean;
  /**渲染子元素 */
  render?: boolean;

  error?: APIError;

  isInit?: boolean;
};

const AsyncWrapper: React.FC<AsyncWrapperProps> = ({
  children,
  loading = false,
  render = true,
  error,
  isInit = false,
}: AsyncWrapperProps) => {
  const [verbose, setVerbose] = useState(false);

  // if (render) {
  //   return <>{children()}</>;
  // }
  if (isInit && error) {
    if (error.status === 401) {
      return null;
    }
  }

  const initTip = IS_POS ? '即将进入系统' : '系统加载中';

  return (
    <div
      className={`${isInit ? styles.init : ''} ${IS_POS ? styles.pos : ''} ${styles.container} ${
        render && loading ? styles.asWrapper : ''
      } ${loading ? styles.loading : ''} ${error ? styles.error : ''}`}>
      {render ? children() : null}
      {loading ? (
        <Loading
          className={styles.loadingCom}
          fullScreen={isInit}
          text={isInit ? initTip : undefined}
        />
      ) : null}
      {loading && render ? <div className={styles.mask} /> : null}

      {error && (
        <Exception
          text={error.msg}
          subText={
            verbose ? (
              <pre className="pre-block mt-s">{JSON.stringify(error, null, 2)}</pre>
            ) : (
              <PosButton
                className="mt-s"
                icon={<DownOutlined />}
                onClick={() => {
                  setVerbose(true);
                }}>
                展开详情
              </PosButton>
            )
          }
          type="error"
        />
      )}
    </div>
  );
};

export default AsyncWrapper;
